var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlima(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    height: "48px",
    width: "48px",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.82,28.7l-2.2,6.66H0.8l7.19-21.16h3.3l7.22,21.16h-2.92l-2.26-6.66H5.82z M12.76,26.57l-2.07-6.09 c-0.47-1.38-0.79-2.64-1.1-3.86H9.52c-0.31,1.26-0.66,2.54-1.07,3.83l-2.07,6.12H12.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.2,36.61l8.76-22.76h2.13L21.3,36.61H19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M47.17,34.67c-1,0.5-3.01,1-5.59,1c-5.97,0-10.46-3.77-10.46-10.71c0-6.62,4.49-11.11,11.05-11.11 c2.64,0,4.3,0.57,5.02,0.94l-0.66,2.23c-1.04-0.5-2.51-0.88-4.27-0.88c-4.96,0-8.26,3.17-8.26,8.73c0,5.18,2.98,8.51,8.13,8.51 c1.66,0,3.36-0.34,4.46-0.88L47.17,34.67z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlima);
export default __webpack_public_path__ + "static/media/klima.b8e905347ed3124e1728535e417f23e1.svg";
export { ForwardRef as ReactComponent };